/* eslint-disable no-console */
import React, {
    useEffect,
    useMemo,
    useRef,
    forwardRef,
    useImperativeHandle,
} from 'react';
import { PopupFilter } from '@fairygodboss/ui';

export const CompaniesFilter = forwardRef(
    (
        {
            isSM,
            companiesOpen,
            companies,
            isCompaniesOpen,
            onCompanySelect,
            bodyRef,
            activeCompanies,
        },
        ref
    ) => {
        const mountedFilters = useRef(activeCompanies);

        useImperativeHandle(ref, () => ({
            setFilter: () => onCompanySelect(mountedFilters.current),
        }));

        useEffect(() => {
            mountedFilters.current = activeCompanies;
        }, [activeCompanies]);

        return useMemo(() => {
            const css = {
                span: {
                    minWidth: '25px',
                },
            };
            if (!isSM) {
                css.paddingRight = '10px';
                css.marginLeft = '0px';
                css.marginRight = '0px';
            }
            return (
                <PopupFilter
                    data-qa="Jobs-Search-Companies-Filter"
                    open={companiesOpen}
                    mr="24px"
                    limitWidth
                    maxWidth="180px"
                    label="Companies"
                    labelName="Companies"
                    isMulti
                    options={companies?.map((c) => ({
                        label: c.displayName,
                        value: c.value,
                        count: c.count,
                    }))}
                    onFilterPress={() => {
                        onCompanySelect(mountedFilters.current);
                        isCompaniesOpen(!companiesOpen);
                    }}
                    onPress={() => null}
                    selectionChange={(val) => {
                        if (!val.length && !companiesOpen) {
                            onCompanySelect(val);
                        }
                        mountedFilters.current = val;
                    }}
                    selector={bodyRef}
                    selection={activeCompanies}
                    css={css}
                />
            );
        }, [
            activeCompanies,
            isSM,
            companiesOpen,
            bodyRef,
            isCompaniesOpen,
            companies,
            onCompanySelect,
        ]);
    }
);
